import React from 'react';

function AddPromoCodeTemplate ({ modelAttributes }) {

	const { SelectedPromoCode } = modelAttributes;

	return (
		<>
			{!SelectedPromoCode && (
				<div className="promoCodeFields">
					<form id="promoCodeForm" className="validationGroup lpForm">
						<div className="field">
							<input
								type="text"
								id="promoCodeInput"
								className="promoInput"
								maxLength="50"
								placeholder="Coupon Code"
								title="Enter promotional code here"
								aria-label="Coupon Code"
								aria-describedby="promoCodeInput-error"
							/>
							<div className="validationMessage hidden promoCodeError tac">
								<span id="promoCodeInput-error" className="error">
									This field is required.
								</span>
							</div>
						</div>
						<button type="button" className="promoButton calloutBtn alt2">
							Apply
						</button>
					</form>
				</div>
			)}
		</>
	);

}

export default AddPromoCodeTemplate;
